module.exports = __webpack_public_path__ + "img/rsz_image1-removebg-preview.01efff59.png";